require('./_wks-define')('asyncIterator');


/*****************
 ** WEBPACK FOOTER
 ** C:/dev/www/Iteca/SitoWeb/~/core-js/modules/es7.symbol.async-iterator.js
 ** module id = 309
 ** module chunks = 0
 **/